import { forwardRef, type SVGProps } from 'react';

export interface CropToolIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const CropToolIcon = forwardRef<SVGSVGElement, CropToolIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <g clip-path="url(#a)" fill="currentColor">
      <path d="M4.75 11.5H14.875C15.2202 11.5 15.5 11.7798 15.5 12.125C15.5 12.4702 15.2202 12.75 14.875 12.75H3.5V6H4.75V11.5ZM4.125 0.5C4.47018 0.5 4.75 0.779822 4.75 1.125V4H3.5V1.125C3.5 0.779822 3.77982 0.5 4.125 0.5Z" />
      <path d="M11.25 5.25 1.125 5.25C.78 5.25.5 4.97.5 4.625.5 4.28.78 4 1.125 4L12.5 4 12.5 11.5 11.25 11.5 11.25 5.25ZM12.5 13.25 11.25 13.25 11.25 14.875C11.25 15.22 11.53 15.5 11.875 15.5 12.22 15.5 12.5 15.22 12.5 14.875L12.5 13.25Z" />
    </g>
    <defs>
      <clipPath id="a">
        <rect fill="currentColor" height="16" width="16" />
      </clipPath>
    </defs>
  </svg>
));

CropToolIcon.displayName = 'CropToolIcon';
